<div class="loading-screen" role="status" aria-live="polite" aria-busy="true">
  <div class="dots" aria-hidden="true">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</div>